import api from 'plugin/api';
import { API_URL } from 'types/const';
import isJSON from 'utils/isJSON';
import jsonToFormData from 'utils/json/toFormData';
import format from 'utils/string/format';

/**
 * 배합비 코드 목록 조회
 * @param {Object} params 요청 데이터
 * @param {number[]} params.factoryCodeSeqList 선택한 공장
 * @param {string} [params.mixCd] 배합비 코드
 * @param {string} [params.useYn] 사용 유무
 * @return {Object} 응답 데이터
 */
async function requestList(params) {
  return api.get(API_URL.standard.code.mix.default, { params });
}

/**
 * 배합비 코드 추가
 * @param {Object} data 요청 데이터
 * @param {number} data.factoryCodeSeq 공장 코드
 * @param {string} data.mixCd 배합비 코드
 * @param {string} data.mixNm 배합비 명
 * @param {'Y' | 'N'} data.useYn 사용 여부
 * @param {Object[]} data.productInMixList 제품 목록
 * @param {'Y' | 'N'} data.productInMixList[].useYn 마스터
 * @param {string} data.productInMixList[].prdtCd 제품 코드
 * @return {Object} 응답 데이터
 */
async function requestInsert(data) {
  return api.post(API_URL.standard.code.mix.default, data);
}

/**
 * 배합비 코드 수정
 * @param {number} seq 배합비 코드 번호
 * @param {Object} data 요청 데이터
 * @param {'Y' | 'N'} data.useYn 사용 여부
 * @param {Object[]} data.productInMixList 제품 목록
 * @param {'Y' | 'N'} data.productInMixList[].useYn 마스터
 * @param {string} data.productInMixList[].prdtCd 제품 코드
 * @return {Object} 응답 데이터
 */
async function requestUpdate(seq, data) {
  return api.put(format(API_URL.standard.code.mix.inform, { seq }), data);
}

/**
 * 배합비 코드 정보 조회
 * @param {number} seq 배합비 코드 번호
 * @return {Object} 응답 데이터
 */
async function requestInform(seq) {
  return api.get(format(API_URL.standard.code.mix.inform, { seq }));
}

/**
 * 배합비 코드 업로드 폼 다운로드
 * @return {Object} 응답 데이터
 */
async function requestDownload() {
  return api.get(API_URL.standard.code.mix.download, {
    responseType: 'arraybuffer'
  });
}

/**
 * 배합비 코드 업로드
 * @param {Object} data 요청 데이터
 * @param {number} data.factoryCodeSeq 공장 코드
 * @param {File} data.file xlsx 파일
 * @return {Object} 응답 데이터
 */
async function requestUpload(data) {
  if (isJSON(data)) {
    data = jsonToFormData(data);
  }

  return api.post(API_URL.standard.code.mix.upload, data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
}

export {
  requestList,
  requestInsert,
  requestUpdate,
  requestInform,
  requestDownload,
  requestUpload
};
